import type { CreateItemUploadLockResponseDto, UploadLocationId } from '@mimir/common/dto/uploadLocationDto';
import { requestCreateItemUploadLock } from '@mimir/common/api/uploadApi';
import { api_getTenantConfigDefaultUploadLocation } from '../util/api';
import type { LocationDto } from '@mimir/common/dto/bucketConfigDto';
import { httpErrorStatus } from '@mimir/common/util/httpError';
import type { BackendClient } from '@mimir/common/util/backendClient';

export async function requestItemUploadLock(maxChunkSize: number, multipartThreshold: number,
                                            client: BackendClient,
                                            itemId: string, uploadLocationId: UploadLocationId,
                                            fileSize: number, contentType: string,
                                            targetFolder: string | undefined, lockOwnerInstanceId: string): Promise<CreateItemUploadLockResponseDto> {
  return requestCreateItemUploadLock(client, maxChunkSize, multipartThreshold, itemId, uploadLocationId, fileSize, contentType, targetFolder, lockOwnerInstanceId);
}

export async function isDefaultUploadS3Clone(c: BackendClient, uploadLocation?: LocationDto | null) {
  let dto: LocationDto | null | Record<string, never>;
  if (uploadLocation === undefined) {
    try {
      dto = await api_getTenantConfigDefaultUploadLocation(c);
    } catch (e: any) {
      if (httpErrorStatus(e) === 404) {
        // It may happen that the default upload location returns a 404
        // when the previous default upload location was deleted
        // via the REST API
        return false;
      }
      throw e;
    }
  } else {
    dto = uploadLocation;
  }

  return dto !== null && dto.type === 's3Clone';
}
